import useGcsMarkdownLoader from '@/content-viewer/hooks/useGcsMarkdownLoader'
import HTMLBaseRenderer from '../base-renderers/HTMLBaseRenderer'
import ContentViewerErrorState from '../common/ContentViewerErrorState'
import ContentViewerLoadingSpinner from '../common/ContentViewerLoadingStates'

type MarkdownRendererProps = {
  filePath: string
  gcsBucketName: string
  legacy_always_cloud?: boolean
  highlightSentences?: string[] | null
}

/**
 * MarkdownRenderer Component
 *
 * Renders markdown files with sentence highlights.
 * Used for FILE_UPLOAD references with markdown format.
 *
 * @param props.filePath - GCS file path to the markdown file
 * @param props.gcsBucketName - GCS bucket name
 * @param props.highlightSentences - Optional sentences to highlight
 */
export default function MarkdownRenderer(props: MarkdownRendererProps): JSX.Element {
  const { filePath, gcsBucketName, legacy_always_cloud = true, highlightSentences } = props

  const { htmlString, isLoading, hasError, retry } = useGcsMarkdownLoader({
    gcsBucketName,
    filePath,
    highlights: highlightSentences,
    legacy_always_cloud,
  })

  if (isLoading) {
    return <ContentViewerLoadingSpinner size="small" />
  }

  if (hasError || !htmlString) {
    return <ContentViewerErrorState message="Failed to load markdown content." onRetry={retry} />
  }

  return <HTMLBaseRenderer htmlContent={htmlString} highlightSentences={highlightSentences ?? undefined} />
}
